import React from 'react'
import Breadcrumb from '../breadcrumb'
import { PAGE_TITLE_HOME } from '../../config'

const PageHeading = (props) => {
  const isHome = props.pageTitle.toLowerCase() === PAGE_TITLE_HOME
  let logo = null
  if (props.logo && isHome) {
    logo = (
      <span className='animated fadeIn'>
        <img src={props.logo} alt={'logo'} border='0' style={{ maxHeight: '46px', marginTop: '10px' }} />
      </span>
    )
  }
  return (
    <div
      className='row wrapper border-bottom white-bg page-heading'
      style={{ paddingTop: 0, paddingBottom: 0, height: '67px' }}
    >
      <div className='col-lg-10'>
        {isHome ? (
          logo
        ) : (
          <div>
            <h2 style={{ marginTop: '8px', marginBottom: '8px' }}>{props.pageTitle}</h2>
            <Breadcrumb navigate={props.navigate} location={props.location} />
          </div>
        )}
      </div>
      <div className='col-lg-2' />
    </div>
  )
}

export default PageHeading
